// extracted by mini-css-extract-plugin
export default {"wrapper":"UserAgreement_wrapper__jro2B","title":"UserAgreement_title__kkAI2","inner":"UserAgreement_inner__d-aSC"};